import { ShippingReport, ShippingSearch, ShippingSearchDownload, SortOrder } from '@app/core/models';
import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { sortObjects } from '../../utils/functional';
import { ASC, DESC } from '../../utils/sorting';
import {
  loadShippingSearchDownloadsSuccess,
  saveShippingReportSuccess,
  saveShippingSearchSuccess,
  setShippingSearchDownloadsSortOrder,
  unloadShippingReport
} from '../actions/order.actions';

export interface OrdersState {
  shippingSearch?: ShippingSearch;
  shippingReport?: ShippingReport;
  shippingSearchDownloads?: ShippingSearchDownload[];
  shippingSearchDownloadConfirmedForDeletion?: ShippingSearchDownload;
  shippingSearchDownloadToDelete?: ShippingSearchDownload;
  shippingSearchDownloadsSortOrder?: SortOrder;
}

const initialState: OrdersState = {
  shippingSearch: null,
  shippingReport: null,
  shippingSearchDownloads: null,
  shippingSearchDownloadConfirmedForDeletion: null,
  shippingSearchDownloadToDelete: null,
  shippingSearchDownloadsSortOrder: {
    key: 'runDateTime',
    direction: DESC
  },
};

export const ordersReducer = createReducer(
  initialState,
  on(saveShippingSearchSuccess, (state, action) => ({ ...state, shippingSearch: action.payload })),
  on(saveShippingReportSuccess, (state, action) => ({ ...state, shippingReport: action.payload })),
  on(unloadShippingReport, (state) => ({ ...state, shippingReport: null })),
  on(loadShippingSearchDownloadsSuccess, (state, action) => ({ ...state, shippingSearchDownloads: sortObjects(action.payload, state.shippingSearchDownloadsSortOrder) })),
  on(setShippingSearchDownloadsSortOrder, (state, action) => {

    const newSortOrder = { key: action.payload, direction: state.shippingSearchDownloadsSortOrder.direction } as SortOrder;

    if (newSortOrder.key === state.shippingSearchDownloadsSortOrder.key) {
      // same key, toggle sort direction
      newSortOrder.direction = state.shippingSearchDownloadsSortOrder.direction === ASC ? DESC : ASC;
    } else {
      // different key, sort by key and initial state direction
      newSortOrder.direction = initialState.shippingSearchDownloadsSortOrder.direction;
    }

    const shippingSearchDownloads = sortObjects(state.shippingSearchDownloads, newSortOrder);
    return Object.assign({}, state, {
      shippingSearchDownloads,
      shippingSearchDownloadsSortOrder: newSortOrder
    } as OrdersState);

  })
);

export const selectOrdersState = createFeatureSelector<OrdersState>('ordersState');



